// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-text {
  font-size: 1.1rem;
  text-align: center;
}

.validation {
  color: red;
}

.content-fixture {
  font-size: 1.4rem;
  font-weight: 600;
}

.modal-footer {
  justify-content: center;
}

.notes-area {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  background-color: #FCFCFC;
  width: 100%;
  height: 160px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/reject-confirm/lfp/approve-reject-confirm.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ;;AACA;EACI,uBAAA;AAEJ;;AACA;EACI,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;AAEJ","sourcesContent":[".content-text {\n    font-size: 1.1rem;\n    text-align: center;\n}\n\n.validation{\n    color: red;\n}\n\n.content-fixture {\n    font-size: 1.4rem;\n    font-weight: 600;\n}\n.modal-footer {\n    justify-content: center;\n}\n\n.notes-area {\n    border: 1px solid #EBE9EB;\n    border-radius: 3px;\n    background-color: #FCFCFC;\n    width: 100%;\n    height: 160px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
